<template>
  <div style="padding: 10px">
    <el-form :model="formData" label-width="10px">

      <el-row style="margin-bottom: 10px">
        <el-col :span="8">
          <el-input v-model="formData.customer_name" class="form-item" placeholder="客户名称" clearable/>
        </el-col>
        <el-col :span="8">
          <el-input v-model="formData.logistics_company" class="form-item" placeholder="物流公司" clearable/>
        </el-col>
        <el-col :span="8">
          <el-input v-model="formData.logistics_no" class="form-item" placeholder="物流单号" clearable/>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 15px">
        <el-col :span="8">
          <el-select v-model="formData.store_id" class="form-item" placeholder="到达仓库" clearable>
            <el-option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-date-picker v-model="formData.send_date" class="form-item" style="width: 260px" placeholder="发货日期" clearable/>
        </el-col>
        <el-col :span="8">
          <el-button @click="addMaterial(3)">添加物料行</el-button>
        </el-col>
      </el-row>

    </el-form>

    <el-row class="box">
      <el-col :span="17">物料名称</el-col>
      <el-col :span="6">来料数量</el-col>
      <el-col :span="1"></el-col>
    </el-row>

    <div style="height:290px;overflow-y: auto;overflow-x: hidden">
      <el-row v-for="item in formData.item_list" :key="item.material_id" class="row" :gutter="15">
        <el-col :span="17">
          <el-select
              v-model="item.id"
              placeholder="选择物料"
              remote
              :remote-method="remoteMethod"
              @focus="selectFocus(item.nanoid)"
              :loading="remoteLoading"
              style="width: 100%" clearable filterable>
            <el-option v-for="item in item.materialList" :key="item.id" :label="'【'+item.code+'】'+item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input v-model="item.cnt" placeholder="来料数量" style="width: 100%"></el-input>
        </el-col>
        <el-col :span="1">
          <div class="close" @click="removeOneMaterial(item.nanoid)">
            <el-icon>
              <ElIconClose></ElIconClose>
            </el-icon>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row style="margin-top: 15px">
      <el-col :span="24">
        <el-input type="textarea" class="quote-remark" v-model="formData.remark" placeholder="来料单备注" style="width: 100%" :autosize="true"></el-input>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="createIncoming" :loading="loading">创建来料单</el-button>
    </el-form-item>
  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "CreateIncoming",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        customer_name: '',
        logistics_company: '',
        logistics_no: '',
        send_date: new Date(),
        store_id: '',
        item_list: []
      },
      storeList: [],
      loading: false,
      remoteLoading: false,
      focusNanoid: ''
    }
  },
  computed: {},
  created() {
    this.getStoreList()
    this.addMaterial(6)
  },
  methods: {
    selectFocus(nanoid) {
      this.focusNanoid = nanoid;
    },
    async remoteMethod(query) {
      this.remoteLoading = true
      this.$http('wmsMaterialService.getRemoteDs', {value: query}, false).then(data => {
        this.remoteLoading = false
        let item = this.formData.item_list.find(item => item.nanoid === this.focusNanoid);
        item.materialList = data
      }, errMsg => {
        this.remoteLoading = false
        this.$message.error(errMsg);
      })
    },
    getStoreList() {
      this.$axios.get('wms/store/getStoreList?personal=false&sameCity=true').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取仓库列表失败");
        }

        this.storeList = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    getItemLabel(item) {
      return item.name + '(' + item.code + ')';
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()
    },
    clearPreData() {
      //清空表单数据
      this.formData.item_list = []
      this.formData.logistics_company = '';
      this.formData.logistics_no = '';
      this.addMaterial(6);
    },
    async createIncoming() {

      if (this.formData.customer_name == '') {
        return this.$message.error("未输入客户名称");
      }

      if (this.formData.logistics_company == '') {
        return this.$message.error("未输入物流公司");
      }

      if (this.formData.logistics_no == '') {
        return this.$message.error("未输入物流单号");
      }

      if (this.formData.send_date == null) {
        return this.$message.error("未输入发货日期");
      }

      if (this.formData.store_id == '') {
        return this.$message.error("未选择仓库");
      }

      var cnt = 0;
      for (let i = 0; i < this.formData.item_list.length; i++) {
        let obj = this.formData.item_list[i]
        if (obj.id) {

          if (!obj.cnt) {
            return this.$message.error(`第${i + 1}行数量不能为空`);
          }

          cnt++;
          obj.has_data = true;
        }
      }

      if (cnt == 0) {
        return this.$message.error("来料明细数据不能为空");
      }

      await this.$http('wmsIncomingService.create', this.formData);
      this.$message.success("提交成功");
      this.$fn.closeWindow();
      this.$fn.search();
      this.clearPreData();

    },
    addMaterial(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.formData.item_list.push({
          nanoid: nanoid(),
          productDetails: {},
          materialList: [],
        })
      }
    },
    removeOneMaterial(nanoid) {
      let index = this.formData.item_list.findIndex(item => item.nanoid === nanoid);
      this.formData.item_list.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 260px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>